import { html } from 'fxjs/es';

export const myPageEmptyWishTmpl = ({ title, description }) => {
  return html`<div class="omp-my-wish__empty">
    <span class="omp-my-wish__empty-title">${title}</span>
    <span class="omp-my-wish__empty-description">${description}</span>
  </div> `;
};
